import styled from "styled-components";

import { colors } from "@ntemarked/mittne-components";

interface InnkjoepsbestillingTextProps {
	skipEnergiMail: boolean;
	created?: boolean;
}

/** Om innkjøpsbestilling sendes til NTE Energi. «ikke» er uthevet, så et fravalg ikke blir oversett. */
export function InnkjoepsbestillingText({ skipEnergiMail, created = false }: Readonly<InnkjoepsbestillingTextProps>) {
	if (!skipEnergiMail) return <>{created ? "Sendt" : "Sendes"} til NTE Energi</>;
	return created ? (
		<>
			<Ikke>Ikke</Ikke> sendt til NTE Energi
		</>
	) : (
		<>
			Sendes <Ikke>ikke</Ikke> til NTE Energi
		</>
	);
}

const Ikke = styled.strong`
	padding: 1px 6px;
	border-radius: 4px;
	background: ${colors.yellow};
	color: ${colors.grey900};
	text-transform: uppercase;
`;
